import { useChatSupportBasicFeatureGate } from '../../feature-gates/use-chat-support-basic-feature-gate';
import { OpenSierraSource, useOpenSierraInZendesk } from './open-sierra-in-zendesk';

export { OpenSierraSource };

type UseSupportChatResult = {
  isEnabled: boolean;
  openSupportChat: (source: OpenSierraSource) => Promise<void>;
};

export const useSupportChat = (): UseSupportChatResult => {
  const { isFeatureEnabled } = useChatSupportBasicFeatureGate();
  const openSierraInZendesk = useOpenSierraInZendesk();

  return {
    isEnabled: isFeatureEnabled,
    openSupportChat: openSierraInZendesk,
  };
};
